export default __webpack_public_path__ + "static/media/GWC-Audit-Report-092821(1).53f9d374.pdf";